import { render, staticRenderFns } from "./EsDashboardOld.vue?vue&type=template&id=721b033a&"
import script from "./EsDashboardOld.vue?vue&type=script&lang=js&"
export * from "./EsDashboardOld.vue?vue&type=script&lang=js&"
import style0 from "./EsDashboardOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports